// extracted by mini-css-extract-plugin
module.exports = {"home":"youtube_home__1QJ0m","videoContainer":"youtube_videoContainer__2455M"};